module.exports={
	"Scope": "User-List",
	"CoreEntity": "User",
	"TitleTemplate": "Users",
	"Descriptors":
	{
		"NameFirst":
		{
			"Name": "First Name",
			"Hash": "UserListFirstName",
			"PictDashboard": {}
		},
		"NameLast":
		{
			"Name": "Last Name",
			"Hash": "UserListLastName",
			"PictDashboard": {}
		},
		"Email":
		{
			"Name": "Email",
			"Hash": "UserListEmail",
			"PictDashboard": {}
		},
		"LoginID":
		{
			"Name": "Login ID",
			"Hash": "UserListLoginID",
			"PictDashboard": {}
		},
		"Title":
		{
			"Name": "Title",
			"Hash": "UserListTitle",
			"PictDashboard": {}
		}
	}
}
